// src/components/preview-menu/preview-menu.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment IconFragment on Icon {\n    title\n    description\n    id\n    token\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment TertiaryButtonFragment on CommunicationCenterButton {\n    button {\n      ... on UITertiaryButton {\n        __typename\n        primary\n        accessibility\n        icon {\n          ...IconFragment\n        }\n        analytics {\n          eventType\n          linkName\n          referrerId\n        }\n      }\n    }\n    action {\n      ... on UILinkAction {\n        resource {\n          value\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment CommunicationCenterBannerFragment on CommunicationCenterBanner {\n    icon {\n      ...IconFragment\n    }\n    title\n    body\n    theme\n    action {\n      ...TertiaryButtonFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    size\n    text\n    weight\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment CommunicationCenterEmptyStateFragment on CommunicationCenterEmptyState {\n    __typename\n    title {\n      ...EGDSStylizedTextFragment\n    }\n    body {\n      ...EGDSStylizedTextFragment\n    }\n    image {\n      url\n      description\n    }\n    impressionAnalytics {\n      event\n      referrerId\n      linkName\n    }\n    emptyStateType\n    actions {\n      button {\n        ... on UIPrimaryButton {\n          __typename\n          primary\n          analytics {\n            linkName\n            referrerId\n          }\n        }\n      }\n      action {\n        ... on UILinkAction {\n          resource {\n            value\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    graphic {\n      ...IconFragment\n    }\n    text\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment NotificationsLinkFragment on EGDSStandardLink {\n    __typename\n    text\n    size\n    action {\n      resource {\n        value\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment NotificationsItemFragment on CommunicationCenterNotificationCard {\n    __typename\n    cardId\n    title {\n      ...EGDSStylizedTextFragment\n    }\n    body {\n      ...EGDSStylizedTextFragment\n    }\n    type\n    icon {\n      ...IconFragment\n    }\n    links {\n      ...NotificationsLinkFragment\n    }\n    impressionAnalytics {\n      event\n      referrerId\n      linkName\n    }\n    revealActions {\n      referrerId\n      linkName\n      eventType\n    }\n    userActions {\n      __typename\n      icon {\n        id\n        description\n      }\n      type\n      text {\n        size\n        text\n        weight\n      }\n      revealActions {\n        referrerId\n        linkName\n        eventType\n      }\n    }\n    timeStamp {\n      ...EGDSStylizedTextFragment\n    }\n    state\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  mutation UpdateNotificationsInMenuMutation(\n    $contextInput: ContextInput!\n    $notificationIds: [String!]!\n    $state: CommunicationCenterNotificationState!\n  ) {\n    updateNotificationsState(context: $contextInput, notificationIds: $notificationIds, state: $state) {\n      notificationId\n      operationStatus\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  query CommunicationCenterPreviewQuery($context: ContextInput!, $optionalContext: OptionalContextInput) {\n    communicationCenterPreview(context: $context, optionalContext: $optionalContext) {\n      label {\n        ...EGDSStylizedTextFragment\n      }\n      notifications {\n        heading {\n          ...EGDSStylizedTextFragment\n        }\n        unseen\n        notifications {\n          ...NotificationsItemFragment\n        }\n        emptyState {\n          ...CommunicationCenterEmptyStateFragment\n        }\n        impressionAnalytics {\n          event\n          referrerId\n          linkName\n        }\n        clickToActionButton {\n          button {\n            ... on UIPrimaryButton {\n              primary\n              analytics {\n                linkName\n                referrerId\n              }\n            }\n          }\n          action {\n            ... on UILinkAction {\n              resource {\n                value\n              }\n            }\n          }\n        }\n        banner {\n          ...CommunicationCenterBannerFragment\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  query CommunicationCenterPreviewMenuQuery($context: ContextInput!, $optionalContext: OptionalContextInput) {\n    communicationCenterEntryPoint(context: $context, optionalContext: $optionalContext) {\n      __typename\n      icon {\n        id\n        token\n        description\n      }\n      label\n      notificationUnseenCount\n      messageUnseenCount\n      defaultTab\n      clickAnalytics {\n        linkName\n        referrerId\n        eventType\n      }\n      impressionAnalytics {\n        event\n        referrerId\n        linkName\n      }\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  query PreviewMenuGlobalHeaderQuery(\n    $context: ContextInput!\n    $viewSize: HeaderViewSize\n    $lineOfBusiness: GlobalNavigationLineOfBusiness\n    $layout: HeaderLayout\n  ) {\n    globalHeader(context: $context, viewSize: $viewSize, lineOfBusiness: $lineOfBusiness, layout: $layout) {\n      redDotState @client\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
import React16 from "react";
import { gql as gql11, useApolloClient, useQuery } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
// src/components/preview-menu/preview-menu-link-content.tsx
import React from "react";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkFloatingDotNotificationBadge } from "uitk-react-badge";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var CommunicationCenterPreviewMenuLinkContent = function(props) {
    var _clickAnalytics, _clickAnalytics1, _clickAnalyticsForMessage, _clickAnalyticsForMessage1, _impressionAnalytics, _impressionAnalytics1;
    var analyticsTracker = useClickTracker();
    var unseen = props.unseen, unread = props.unread, label = props.label, impressionAnalytics = props.impressionAnalytics, clickAnalytics = props.clickAnalytics, clickAnalyticsForMessage = props.clickAnalyticsForMessage;
    var referrerId = (_clickAnalytics = clickAnalytics) === null || _clickAnalytics === void 0 ? void 0 : _clickAnalytics.referrerId;
    var linkName = (_clickAnalytics1 = clickAnalytics) === null || _clickAnalytics1 === void 0 ? void 0 : _clickAnalytics1.linkName;
    var messageReferrerId = (_clickAnalyticsForMessage = clickAnalyticsForMessage) === null || _clickAnalyticsForMessage === void 0 ? void 0 : _clickAnalyticsForMessage.referrerId;
    var messageLinkName = (_clickAnalyticsForMessage1 = clickAnalyticsForMessage) === null || _clickAnalyticsForMessage1 === void 0 ? void 0 : _clickAnalyticsForMessage1.linkName;
    var totalUnseenCount = unseen + unread;
    var unseenState = totalUnseenCount > 0;
    var _React_useState = _sliced_to_array(React.useState(unseenState), 2), isUnSeen = _React_useState[0], setUnSeen = _React_useState[1];
    var impressionReferrerId = (_impressionAnalytics = impressionAnalytics) === null || _impressionAnalytics === void 0 ? void 0 : _impressionAnalytics.referrerId;
    var impressionLinkName = ((_impressionAnalytics1 = impressionAnalytics) === null || _impressionAnalytics1 === void 0 ? void 0 : _impressionAnalytics1.linkName) || "";
    var onMenuLinkClick = function() {
        setUnSeen(false);
        if (referrerId && linkName) {
            analyticsTracker(referrerId, linkName, void 0, []);
        }
        if (messageReferrerId && messageLinkName) {
            analyticsTracker(messageReferrerId, messageLinkName, void 0, []);
        }
    };
    return /* @__PURE__ */ React.createElement("a", {
        href: "/inbox/notifications"
    }, /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: {
            block: "three",
            inline: "six"
        }
    }, /* @__PURE__ */ React.createElement(UitkLink, {
        onClick: onMenuLinkClick
    }, /* @__PURE__ */ React.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, null, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkText, {
        size: 300,
        theme: "default"
    }, label)), /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, impressionReferrerId && /* @__PURE__ */ React.createElement(IntersectionTracker, {
        referrerId: impressionReferrerId,
        linkName: impressionLinkName
    }, isUnSeen && /* @__PURE__ */ React.createElement(UitkFloatingDotNotificationBadge, {
        visible: true
    }))))))));
};
CommunicationCenterPreviewMenuLinkContent.displayName = "sharedui-CommunicationCenterPreviewMenuLinkContent";
// src/components/preview-menu/preview-menu-wrapper.tsx
import React15 from "react";
// src/components/preview-menu/preview-menu-content-wrapper.tsx
import React13 from "react";
import { gql as gql10, useLazyQuery } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker5, useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/comm-center-banner/comm-center-banner.tsx
import React4, { useEffect } from "react";
import { gql as gql3 } from "@apollo/client";
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkBanner } from "uitk-react-banner";
import { UitkButtonSize as UitkButtonSize2 } from "uitk-react-button";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
import { UitkLayoutItem } from "uitk-react-layout";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
// ../internal/src/components/utils/uitk-text-utils.ts
import { UitkFigureAspectRatioType } from "uitk-react-images";
var _obj;
var UitkTextWeightMap = (_obj = {}, _define_property(_obj, "BOLD" /* BOLD */ , "bold"), _define_property(_obj, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj, "REGULAR" /* REGULAR */ , "regular"), _obj);
var TextSizeToUitkTextSizeMap = {
    "100": 100,
    "200": 200,
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800,
    "900": 900
};
var _obj1;
var AspectRatioMap = (_obj1 = {}, _define_property(_obj1, "ONE_ONE" /* ONE_ONE */ , UitkFigureAspectRatioType.R1_1), _define_property(_obj1, "FOUR_THREE" /* FOUR_THREE */ , UitkFigureAspectRatioType.R4_3), _define_property(_obj1, "SIXTEEN_NINE" /* SIXTEEN_NINE */ , UitkFigureAspectRatioType.R16_9), _define_property(_obj1, "THREE_TWO" /* THREE_TWO */ , UitkFigureAspectRatioType.R3_2), _define_property(_obj1, "THREE_FOUR" /* THREE_FOUR */ , UitkFigureAspectRatioType.R3_4), _define_property(_obj1, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , UitkFigureAspectRatioType.R21_9), _define_property(_obj1, "FOUR_ONE" /* FOUR_ONE */ , UitkFigureAspectRatioType.R4_1), _obj1);
var BannerThemesMap = {
    error: "error",
    critical: "critical"
};
// ../internal/src/components/comm-center-button/comm-center-tertiary-button/comm-center-tertiary-button.tsx
import React3 from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React2 from "react";
import { gql } from "@apollo/client";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var fragment = gql(_templateObject());
var Icon = function(param) {
    var data = param.data, isIconOnly = param.isIconOnly, onClick = param.onClick;
    var id = data.id, title = data.title, description = data.description;
    var iconBaseProps = {
        name: id,
        id: id,
        title: title || id,
        description: description || id
    };
    if (isIconOnly) {
        return /* @__PURE__ */ React2.createElement(UitkIcon, _object_spread_props(_object_spread({}, iconBaseProps), {
            size: UitkIconSize.MEDIUM
        }));
    }
    var handleClick = function() {
        if (onClick) {
            onClick();
        }
    };
    return /* @__PURE__ */ React2.createElement(UitkTertiaryButton, {
        tag: "a",
        href: "#",
        onClick: handleClick
    }, /* @__PURE__ */ React2.createElement(UitkIcon, _object_spread({}, iconBaseProps)));
};
Icon.fragment = fragment;
Icon.displayName = "Icon";
// ../internal/src/components/comm-center-button/comm-center-tertiary-button/comm-center-tertiary-button.tsx
var fragment2 = gql2(_templateObject1(), Icon.fragment);
var CommunicationCenterTertiaryButton = function(param) {
    var data = param.data, buttonSize = param.buttonSize, inverse = param.inverse, onClick = param.onClick, disabled = param.disabled, tag = param.tag;
    var _action, _button, _button1, _button2;
    var button = data.button, action = data.action;
    var trackClick = useClickTracker2();
    var handleOnClick = function() {
        var _button, _onClick;
        if (((_button = button) === null || _button === void 0 ? void 0 : _button.__typename) === "UITertiaryButton" && button.analytics) {
            var _button_analytics = button.analytics, referrerId = _button_analytics.referrerId, linkName = _button_analytics.linkName;
            trackClick(referrerId, linkName);
        }
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick();
    };
    var baseButtonProps = _object_spread({
        href: (_action = action) === null || _action === void 0 ? void 0 : _action.resource.value,
        size: buttonSize,
        disabled: disabled,
        inverse: inverse,
        onClick: handleOnClick,
        tag: tag,
        target: tag ? "_blank" : ""
    }, ((_button = button) === null || _button === void 0 ? void 0 : _button.__typename) === "UITertiaryButton" && ((_button1 = button) === null || _button1 === void 0 ? void 0 : _button1.accessibility) ? {
        "aria-label": button.accessibility
    } : {});
    return /* @__PURE__ */ React3.createElement(React3.Fragment, null, ((_button2 = button) === null || _button2 === void 0 ? void 0 : _button2.__typename) === "UITertiaryButton" && /* @__PURE__ */ React3.createElement(UitkTertiaryButton2, _object_spread_props(_object_spread({}, baseButtonProps), {
        "data-stid": "tertiary-button"
    }), button.icon && /* @__PURE__ */ React3.createElement(UitkIcon2, {
        name: button.icon.id
    }), button.primary));
};
CommunicationCenterTertiaryButton.fragment = fragment2;
CommunicationCenterTertiaryButton.displayName = "CommunicationCenterTertiaryButton";
// ../internal/src/components/comm-center-banner/comm-center-banner.tsx
var __Fragment = gql3(_templateObject2(), Icon.fragment, CommunicationCenterTertiaryButton.fragment);
var CommunicationCenterBanner = function(props) {
    var data = props.data, onBannerClick = props.onBannerClick, onComponentMountCallback = props.onComponentMountCallback, isFlexLayout = props.isFlexLayout;
    var action = data.action, body = data.body, icon = data.icon, title = data.title, theme = data.theme;
    useEffect(function() {
        if (onComponentMountCallback) {
            onComponentMountCallback();
        }
    }, []);
    var handleBannerClick = function() {
        if (onBannerClick) {
            onBannerClick();
        }
    };
    var renderCommCenterBanner = function() {
        var _action_button, _action;
        if (body) {
            return /* @__PURE__ */ React4.createElement(UitkBanner, {
                theme: BannerThemesMap[theme]
            }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex2, {
                alignItems: "center",
                space: "two"
            }, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React4.createElement("div", null, /* @__PURE__ */ React4.createElement(UitkIcon3, {
                name: icon.id,
                spotlight: {
                    theme: "standard",
                    background: false
                }
            }))), /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React4.createElement("div", null, /* @__PURE__ */ React4.createElement(UitkText2, {
                weight: "bold"
            }, title), /* @__PURE__ */ React4.createElement(UitkText2, {
                weight: "regular"
            }, body)))));
        }
        return /* @__PURE__ */ React4.createElement(UitkBanner, {
            theme: BannerThemesMap[theme]
        }, /* @__PURE__ */ React4.createElement(UitkLayoutGrid, {
            columns: [
                "min-content",
                "max-content",
                "max-content"
            ],
            areas: [
                "icon text action"
            ],
            alignItems: "center",
            space: {
                column: "four"
            }
        }, /* @__PURE__ */ React4.createElement(UitkLayoutGridItem, {
            area: "icon"
        }, /* @__PURE__ */ React4.createElement(UitkIcon3, {
            name: icon.id,
            description: icon.description
        })), /* @__PURE__ */ React4.createElement(UitkLayoutGridItem, {
            area: "text"
        }, /* @__PURE__ */ React4.createElement(UitkText2, null, title)), /* @__PURE__ */ React4.createElement(UitkLayoutGridItem, {
            area: "action"
        }, ((_action = action) === null || _action === void 0 ? void 0 : (_action_button = _action.button) === null || _action_button === void 0 ? void 0 : _action_button.__typename) === "UITertiaryButton" && /* @__PURE__ */ React4.createElement(CommunicationCenterTertiaryButton, {
            buttonSize: UitkButtonSize2.MEDIUM,
            data: action,
            onClick: handleBannerClick,
            inverse: true
        }))));
    };
    var renderCommCenterBannerForSmallViewport = function() {
        var _action_button, _action, _action_action, _action1, _action2;
        if (body) {
            return /* @__PURE__ */ React4.createElement(UitkBanner, {
                theme: BannerThemesMap[theme]
            }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex2, {
                direction: "column"
            }, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React4.createElement(UitkText2, {
                weight: "bold"
            }, title)), /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React4.createElement(UitkText2, {
                weight: "regular"
            }, body))));
        }
        return /* @__PURE__ */ React4.createElement(UitkBanner, {
            theme: BannerThemesMap[theme]
        }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex2, {
            direction: "column"
        }, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React4.createElement(UitkText2, {
            weight: "medium"
        }, title)), /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React4.createElement(UitkSpacing2, {
            padding: {
                blockend: "one",
                blockstart: "two"
            }
        }, /* @__PURE__ */ React4.createElement(UitkLink2, {
            theme: "default"
        }, ((_action = action) === null || _action === void 0 ? void 0 : (_action_button = _action.button) === null || _action_button === void 0 ? void 0 : _action_button.__typename) === "UITertiaryButton" && /* @__PURE__ */ React4.createElement("a", {
            href: (_action1 = action) === null || _action1 === void 0 ? void 0 : (_action_action = _action1.action) === null || _action_action === void 0 ? void 0 : _action_action.resource.value,
            onClick: handleBannerClick
        }, (_action2 = action) === null || _action2 === void 0 ? void 0 : _action2.button.primary))))));
    };
    if (isFlexLayout) {
        var _action_button, _action, _action_action, _action1, _action2;
        var flexBody = /* @__PURE__ */ React4.createElement(UitkLink2, {
            theme: "default",
            inline: true
        }, ((_action = action) === null || _action === void 0 ? void 0 : (_action_button = _action.button) === null || _action_button === void 0 ? void 0 : _action_button.__typename) === "UITertiaryButton" && /* @__PURE__ */ React4.createElement("a", {
            href: (_action1 = action) === null || _action1 === void 0 ? void 0 : (_action_action = _action1.action) === null || _action_action === void 0 ? void 0 : _action_action.resource.value,
            onClick: handleBannerClick
        }, (_action2 = action) === null || _action2 === void 0 ? void 0 : _action2.button.primary));
        if (body) {
            flexBody = /* @__PURE__ */ React4.createElement(UitkText2, {
                weight: "medium"
            }, body);
        }
        return /* @__PURE__ */ React4.createElement(React4.Fragment, null, data && /* @__PURE__ */ React4.createElement(UitkBanner, {
            theme: BannerThemesMap[theme]
        }, /* @__PURE__ */ React4.createElement(UitkLayoutFlex2, {
            alignItems: "center",
            space: "four"
        }, /* @__PURE__ */ React4.createElement(UitkLayoutItem, null, /* @__PURE__ */ React4.createElement(UitkIcon3, {
            name: icon.id,
            description: icon.description
        })), /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React4.createElement("div", null, /* @__PURE__ */ React4.createElement(UitkText2, {
            weight: "bold"
        }, title), flexBody)))));
    }
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, data && /* @__PURE__ */ React4.createElement(Viewport, null, /* @__PURE__ */ React4.createElement(ViewSmall, null, renderCommCenterBannerForSmallViewport()), /* @__PURE__ */ React4.createElement(ViewMedium, null, renderCommCenterBannerForSmallViewport()), /* @__PURE__ */ React4.createElement(ViewLarge, null, renderCommCenterBanner())));
};
CommunicationCenterBanner.displayName = "CommunicationCenterBanner";
CommunicationCenterBanner.fragment = __Fragment;
CommunicationCenterBanner.fragment.__typename = "CommunicationCenterBanner";
// ../internal/src/components/comm-center-empty-state/comm-center-empty-state.tsx
import React6 from "react";
import { gql as gql5 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker2, useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize3, UitkFloatingFullWidthButton } from "uitk-react-button";
import { UitkCardContentSection } from "uitk-react-cards";
import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading } from "uitk-react-text";
// ../internal/src/components/utils/redirect-gss-url.tsx
var redirectGSSUrl = function(redirectPath) {
    var queryParams = "";
    if (typeof window !== "undefined" && window.location !== null) {
        var locationPathname = window.location.pathname ? window.location.pathname : "";
        var locationSearch = window.location.search ? window.location.search : "";
        var locationHash = window.location.hash ? window.location.hash : "";
        var returnUrl = locationPathname.concat(locationSearch, locationHash);
        queryParams = "?&uurl=".concat(encodeURIComponent("e3id=redr&rurl=".concat(returnUrl)));
    }
    return redirectPath + queryParams;
};
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React5 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment3 = gql4(_templateObject3());
function getWeight(weightOverride, weight) {
    if (weightOverride) {
        return weightOverride;
    }
    if (weight) {
        return UitkTextWeightMap[weight];
    }
    return void 0;
}
var EGDSStylizedText = function(param) {
    var spacing = param.spacing, overflow = param.overflow, weightOverride = param.weightOverride, align = param.align, theme = param.theme, isStriked = param.isStriked, data = param.data, ariaLabelText = param.ariaLabelText;
    var size = data.size, text = data.text, weight = data.weight;
    var textComponentBaseProps = {
        align: align,
        overflow: overflow,
        size: size ? TextSizeToUitkTextSizeMap[size] : void 0,
        spacing: spacing,
        weight: getWeight(weightOverride, weight),
        inline: isStriked ? "s" : void 0,
        theme: theme
    };
    if (ariaLabelText) {
        return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(UitkText3, {
            className: "is-visually-hidden"
        }, ariaLabelText), /* @__PURE__ */ React5.createElement(UitkText3, _object_spread_props(_object_spread({}, textComponentBaseProps), {
            "aria-hidden": "true"
        }), text));
    }
    return /* @__PURE__ */ React5.createElement(UitkText3, _object_spread({}, textComponentBaseProps), text);
};
EGDSStylizedText.fragment = fragment3;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/comm-center-empty-state/comm-center-empty-state.tsx
var fragment4 = gql5(_templateObject4(), EGDSStylizedText.fragment);
var CommunicationCenterEmptyState = function(param) {
    var data = param.data;
    var _body, _actions_, _actions, _actionButton, _clickAnalytics, _clickAnalytics1, _impressionAnalytics, _impressionAnalytics1, _actions__action, _actions_1, _actions1, _image, _image1, _title, _actionButton1, _actionButton2;
    var title = data.title, body = data.body, image = data.image, actions = data.actions, impressionAnalytics = data.impressionAnalytics, emptyStateType = data.emptyStateType;
    var bodyItem = (_body = body) === null || _body === void 0 ? void 0 : _body[0];
    var actionButton = (_actions = actions) === null || _actions === void 0 ? void 0 : (_actions_ = _actions[0]) === null || _actions_ === void 0 ? void 0 : _actions_.button;
    var clickAnalytics = (_actionButton = actionButton) === null || _actionButton === void 0 ? void 0 : _actionButton.analytics;
    var referrerId = (_clickAnalytics = clickAnalytics) === null || _clickAnalytics === void 0 ? void 0 : _clickAnalytics.referrerId;
    var linkName = (_clickAnalytics1 = clickAnalytics) === null || _clickAnalytics1 === void 0 ? void 0 : _clickAnalytics1.linkName;
    var impressionReferrerId = (_impressionAnalytics = impressionAnalytics) === null || _impressionAnalytics === void 0 ? void 0 : _impressionAnalytics.referrerId;
    var impressionLinkName = ((_impressionAnalytics1 = impressionAnalytics) === null || _impressionAnalytics1 === void 0 ? void 0 : _impressionAnalytics1.linkName) || "";
    var analyticsTracker = useClickTracker3();
    var _React6_useState = _sliced_to_array(React6.useState((_actions1 = actions) === null || _actions1 === void 0 ? void 0 : (_actions_1 = _actions1[0]) === null || _actions_1 === void 0 ? void 0 : (_actions__action = _actions_1.action) === null || _actions__action === void 0 ? void 0 : _actions__action.resource.value), 2), redirectPath = _React6_useState[0], setRedirectPath = _React6_useState[1];
    var onEmptyStateButtonClick = function() {
        if (referrerId && linkName) {
            analyticsTracker(referrerId, linkName);
        }
    };
    React6.useEffect(function() {
        if (emptyStateType === "SIGN_IN" /* SIGN_IN */ ) {
            var _actions__action, _actions_, _actions;
            setRedirectPath(redirectGSSUrl((_actions = actions) === null || _actions === void 0 ? void 0 : (_actions_ = _actions[0]) === null || _actions_ === void 0 ? void 0 : (_actions__action = _actions_.action) === null || _actions__action === void 0 ? void 0 : _actions__action.resource.value));
        }
    }, [
        actions,
        emptyStateType
    ]);
    return /* @__PURE__ */ React6.createElement(React6.Fragment, null, impressionReferrerId && /* @__PURE__ */ React6.createElement(IntersectionTracker2, {
        referrerId: impressionReferrerId,
        linkName: impressionLinkName
    }, /* @__PURE__ */ React6.createElement(UitkLayoutFlex3, {
        alignItems: "center",
        justifyContent: "center",
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React6.createElement(UitkCardContentSection, {
        padded: false
    }, /* @__PURE__ */ React6.createElement(UitkSpacing3, {
        padding: {
            inlinestart: "four",
            inlineend: "four",
            blockend: "sixteen"
        }
    }, /* @__PURE__ */ React6.createElement("div", null, /* @__PURE__ */ React6.createElement(UitkLayoutFlexItem3, {
        alignSelf: "center",
        grow: 1,
        maxWidth: 300
    }, /* @__PURE__ */ React6.createElement("section", null, /* @__PURE__ */ React6.createElement(UitkFigure, {
        imageFit: "contain"
    }, /* @__PURE__ */ React6.createElement(UitkImage, {
        alt: (_image = image) === null || _image === void 0 ? void 0 : _image.description,
        src: (_image1 = image) === null || _image1 === void 0 ? void 0 : _image1.url
    })), /* @__PURE__ */ React6.createElement(UitkSpacing3, {
        padding: {
            blockstart: "four",
            blockend: "four"
        }
    }, /* @__PURE__ */ React6.createElement(UitkHeading, {
        align: "center",
        tag: "h1",
        size: 5
    }, (_title = title) === null || _title === void 0 ? void 0 : _title.text)), /* @__PURE__ */ React6.createElement(UitkSpacing3, {
        padding: {
            blockstart: "four",
            blockend: "six"
        }
    }, /* @__PURE__ */ React6.createElement("div", null, /* @__PURE__ */ React6.createElement(EGDSStylizedText, {
        data: bodyItem,
        align: "center"
    }))), ((_actionButton1 = actionButton) === null || _actionButton1 === void 0 ? void 0 : _actionButton1.primary) && /* @__PURE__ */ React6.createElement(UitkFloatingFullWidthButton, {
        tag: "a",
        href: redirectPath,
        size: UitkButtonSize3.LARGE,
        onClick: onEmptyStateButtonClick
    }, (_actionButton2 = actionButton) === null || _actionButton2 === void 0 ? void 0 : _actionButton2.primary)))))))));
};
CommunicationCenterEmptyState.fragment = fragment4;
CommunicationCenterEmptyState.displayName = "CommunicationCenterEmptyState";
// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React7 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkIcon as UitkIcon4 } from "uitk-react-icons";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkText as UitkText4 } from "uitk-react-text";
var fragment5 = gql6(_templateObject5(), Icon.fragment);
var EGDSGraphicText = function(param) {
    var data = param.data, theme = param.theme;
    var graphic = data.graphic, text = data.text;
    return /* @__PURE__ */ React7.createElement(React7.Fragment, null, graphic.__typename === "Icon" && /* @__PURE__ */ React7.createElement(UitkSpacing4, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React7.createElement(UitkIcon4, {
        theme: theme,
        name: graphic.id,
        description: graphic.description
    })), /* @__PURE__ */ React7.createElement(UitkSpacing4, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React7.createElement(UitkText4, {
        theme: theme
    }, text)));
};
EGDSGraphicText.fragment = fragment5;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/notifications-item/notifications-item.tsx
import React11 from "react";
import { gql as gql8 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker3, useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkDotNotificationBadge } from "uitk-react-badge";
import { UitkCardContentSection as UitkCardContentSection2, UitkCardLink } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
// ../internal/src/components/notifications-link/notifications-link.tsx
import React10 from "react";
import { gql as gql7 } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/notifications-list-provider/notifications-list-provider.tsx
import React8, { createContext, useReducer } from "react";
// ../internal/src/components/notifications-list-provider/notifications-list-reducer.ts
var reducer = function(state, action) {
    var initialNotificationsListState = {
        notificationsList: [],
        unseenCount: 0
    };
    var doesPayloadContain = function(notification) {
        var _action_payload_notificationsList, _action_payload;
        var foundNotification = (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : (_action_payload_notificationsList = _action_payload.notificationsList) === null || _action_payload_notificationsList === void 0 ? void 0 : _action_payload_notificationsList.find(function(payloadNotification) {
            return payloadNotification.cardId === notification.cardId;
        });
        return foundNotification !== null && foundNotification !== void 0;
    };
    var setNotificationState = function(notificationState) {
        return state.notificationsList.map(function(notification) {
            if (doesPayloadContain(notification)) {
                return _object_spread_props(_object_spread({}, notification), {
                    state: notificationState
                });
            }
            return notification;
        });
    };
    switch(action.action){
        case 0 /* MARK_AS_UNREAD */ :
            return _object_spread_props(_object_spread({}, state), {
                notificationsList: setNotificationState("SEEN" /* SEEN */ ),
                unseenCount: 0
            });
        case 1 /* MARK_AS_READ */ :
            return _object_spread_props(_object_spread({}, state), {
                notificationsList: setNotificationState("READ" /* READ */ ),
                unseenCount: 0
            });
        case 2 /* DELETE */ :
            {
                return _object_spread_props(_object_spread({}, state), {
                    notificationsList: state.notificationsList.filter(function(notification) {
                        return !doesPayloadContain(notification);
                    }),
                    unseenCount: 0
                });
            }
        default:
            return initialNotificationsListState;
    }
};
// ../internal/src/components/notifications-list-provider/notifications-list-provider.tsx
var DEFAULT = {
    notificationsList: [],
    unseenCount: 0
};
var NotificationsListContext = createContext({
    state: DEFAULT
});
var NotificationsListProvider = function(props) {
    var notificationsList = props.notificationsList, unseenCount = props.unseenCount, children = props.children;
    var _useReducer = _sliced_to_array(useReducer(reducer, _object_spread_props(_object_spread({}, DEFAULT), {
        notificationsList: notificationsList,
        unseenCount: unseenCount
    })), 2), state = _useReducer[0], dispatch = _useReducer[1];
    return /* @__PURE__ */ React8.createElement(NotificationsListContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        }
    }, children || null);
};
var useNotificationsList = function() {
    return React8.useContext(NotificationsListContext);
};
// ../internal/src/components/notifications-update-provider/notifications-update-provider.tsx
import React9, { createContext as createContext2, useContext } from "react";
import { useMutation } from "@apollo/client";
var DEFAULT2 = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    mutation: function() {},
    error: void 0,
    loading: false
};
var NotificationsUpdateContext = createContext2(DEFAULT2);
var NotificationsUpdateProvider = function(props) {
    var mutationFunction = props.mutationFunction, children = props.children;
    var _useMutation = _sliced_to_array(useMutation(mutationFunction), 2), mutation = _useMutation[0], _useMutation_ = _useMutation[1], error = _useMutation_.error, loading = _useMutation_.loading;
    return /* @__PURE__ */ React9.createElement(NotificationsUpdateContext.Provider, {
        value: {
            mutation: mutation,
            error: error,
            loading: loading
        }
    }, children || null);
};
var useUpdateNotificationsMutationState = function() {
    return useContext(NotificationsUpdateContext);
};
// ../internal/src/components/notifications-link/notifications-link.tsx
var fragment6 = gql7(_templateObject6());
var NotificationsLink = function(param) {
    var notification = param.notification, data = param.data, children = param.children;
    var _data_action_resource, _data_action, _data, _data_action_resource1, _data_action1, _data1, _data_action2, _data2, _clickAnalytics, _clickAnalytics1, _notification, _notification1;
    var deeplink = ((_data = data) === null || _data === void 0 ? void 0 : (_data_action = _data.action) === null || _data_action === void 0 ? void 0 : (_data_action_resource = _data_action.resource) === null || _data_action_resource === void 0 ? void 0 : _data_action_resource.value) ? (_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_action1 = _data1.action) === null || _data_action1 === void 0 ? void 0 : (_data_action_resource1 = _data_action1.resource) === null || _data_action_resource1 === void 0 ? void 0 : _data_action_resource1.value : "#";
    var clickAnalytics = (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data_action2 = _data2.action) === null || _data_action2 === void 0 ? void 0 : _data_action2.analytics;
    var referrerId = (_clickAnalytics = clickAnalytics) === null || _clickAnalytics === void 0 ? void 0 : _clickAnalytics.referrerId;
    var linkName = (_clickAnalytics1 = clickAnalytics) === null || _clickAnalytics1 === void 0 ? void 0 : _clickAnalytics1.linkName;
    var analyticsTracker = useClickTracker4();
    var context = useBexApi().context;
    var mutation = useUpdateNotificationsMutationState().mutation;
    var dispatch = useNotificationsList().dispatch;
    var notificationId = (_notification = notification) === null || _notification === void 0 ? void 0 : _notification.cardId;
    var state = (_notification1 = notification) === null || _notification1 === void 0 ? void 0 : _notification1.state;
    var onLinkClick = function() {
        if (referrerId && linkName) {
            analyticsTracker(referrerId, linkName);
        }
        if (state === "SEEN" /* SEEN */ ) {
            dispatch({
                action: 1 /* MARK_AS_READ */ ,
                payload: {
                    notificationsList: [
                        notification
                    ]
                }
            });
            mutation({
                variables: {
                    contextInput: context,
                    notificationIds: [
                        notificationId
                    ],
                    state: "READ" /* READ */ 
                }
            });
        }
    };
    return /* @__PURE__ */ React10.createElement("a", {
        href: deeplink,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: onLinkClick
    }, children);
};
NotificationsLink.fragment = fragment6;
NotificationsLink.displayName = "NotificationsLink";
// ../internal/src/components/notifications-item/notifications-item.tsx
var fragment7 = gql8(_templateObject7(), Icon.fragment, EGDSStylizedText.fragment, NotificationsLink.fragment);
var NotificationsItem = function(param) {
    var data = param.data, children = param.children;
    var _data_impressionAnalytics, _data, _impressionAnalytics, _impressionAnalytics1, _data_links__action, _data_links, _data1, _clickAnalytics, _clickAnalytics1, _data2, _data3, _data_links1, _data_links2, _data_links3, _data_links4, _data_links__action_resource, _data_links__action1, _data_links5, _data_links__action_resource1, _data_links__action2, _data_links6, _data_title, _data_title1, _data_body_, _data_body, _data_body1, _data_timeStamp;
    var impressionAnalytics = (_data = data) === null || _data === void 0 ? void 0 : (_data_impressionAnalytics = _data.impressionAnalytics) === null || _data_impressionAnalytics === void 0 ? void 0 : _data_impressionAnalytics[0];
    var impressionReferrerId = (_impressionAnalytics = impressionAnalytics) === null || _impressionAnalytics === void 0 ? void 0 : _impressionAnalytics.referrerId;
    var impressionLinkName = ((_impressionAnalytics1 = impressionAnalytics) === null || _impressionAnalytics1 === void 0 ? void 0 : _impressionAnalytics1.linkName) || "";
    var clickAnalytics = (_data1 = data) === null || _data1 === void 0 ? void 0 : (_data_links = _data1.links) === null || _data_links === void 0 ? void 0 : (_data_links__action = _data_links[0].action) === null || _data_links__action === void 0 ? void 0 : _data_links__action.analytics;
    var referrerId = (_clickAnalytics = clickAnalytics) === null || _clickAnalytics === void 0 ? void 0 : _clickAnalytics.referrerId;
    var linkName = (_clickAnalytics1 = clickAnalytics) === null || _clickAnalytics1 === void 0 ? void 0 : _clickAnalytics1.linkName;
    var cardId = (_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.cardId;
    var state = (_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.state;
    var analyticsTracker = useClickTracker5();
    var context = useBexApi2().context;
    var mutation = useUpdateNotificationsMutationState().mutation;
    var dispatch = useNotificationsList().dispatch;
    var onLinkClick = function() {
        if (referrerId && linkName) {
            analyticsTracker(referrerId, linkName);
        }
        if (state === "SEEN" /* SEEN */ ) {
            dispatch({
                action: 1 /* MARK_AS_READ */ ,
                payload: {
                    notificationsList: [
                        data
                    ]
                }
            });
            mutation({
                variables: {
                    contextInput: context,
                    notificationIds: [
                        cardId
                    ],
                    state: "READ" /* READ */ 
                }
            });
        }
    };
    return /* @__PURE__ */ React11.createElement(React11.Fragment, null, impressionReferrerId && /* @__PURE__ */ React11.createElement(IntersectionTracker3, {
        referrerId: impressionReferrerId,
        linkName: impressionLinkName
    }, /* @__PURE__ */ React11.createElement(UitkLayoutFlex4, null, /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem4, {
        alignSelf: "start",
        grow: 0
    }, ((_data_links1 = data.links) === null || _data_links1 === void 0 ? void 0 : _data_links1[0]) && /* @__PURE__ */ React11.createElement(NotificationsLink, {
        notification: data,
        data: (_data_links2 = data.links) === null || _data_links2 === void 0 ? void 0 : _data_links2[0]
    }, /* @__PURE__ */ React11.createElement(UitkCardContentSection2, {
        padded: [
            "blockstart",
            "blockend",
            "inlinestart"
        ]
    }, /* @__PURE__ */ React11.createElement(UitkSpacing5, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React11.createElement(UitkDotNotificationBadge, {
        visible: data.state !== "READ" /* READ */ 
    }))))), /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem4, {
        alignSelf: "start",
        grow: 0
    }, ((_data_links3 = data.links) === null || _data_links3 === void 0 ? void 0 : _data_links3[0]) && /* @__PURE__ */ React11.createElement(NotificationsLink, {
        notification: data,
        data: (_data_links4 = data.links) === null || _data_links4 === void 0 ? void 0 : _data_links4[0]
    }, /* @__PURE__ */ React11.createElement(UitkCardContentSection2, {
        padded: [
            "blockstart",
            "blockend",
            "inlinestart"
        ]
    }, data.icon && /* @__PURE__ */ React11.createElement(Icon, {
        data: data.icon,
        isIconOnly: true
    })))), /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem4, {
        grow: 1
    }, /* @__PURE__ */ React11.createElement(UitkCardContentSection2, {
        padded: [
            "blockstart",
            "blockend",
            "inlinestart"
        ]
    }, /* @__PURE__ */ React11.createElement(UitkCardLink, null, /* @__PURE__ */ React11.createElement("a", {
        href: ((_data_links5 = data.links) === null || _data_links5 === void 0 ? void 0 : (_data_links__action1 = _data_links5[0].action) === null || _data_links__action1 === void 0 ? void 0 : (_data_links__action_resource = _data_links__action1.resource) === null || _data_links__action_resource === void 0 ? void 0 : _data_links__action_resource.value) ? (_data_links6 = data.links) === null || _data_links6 === void 0 ? void 0 : (_data_links__action2 = _data_links6[0].action) === null || _data_links__action2 === void 0 ? void 0 : (_data_links__action_resource1 = _data_links__action2.resource) === null || _data_links__action_resource1 === void 0 ? void 0 : _data_links__action_resource1.value : "#",
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: onLinkClick
    }, (_data_title = data.title) === null || _data_title === void 0 ? void 0 : _data_title.text)), ((_data_title1 = data.title) === null || _data_title1 === void 0 ? void 0 : _data_title1.text) && /* @__PURE__ */ React11.createElement(UitkHeading2, {
        tag: "h2",
        size: 5
    }, data.title.text), ((_data_body = data.body) === null || _data_body === void 0 ? void 0 : (_data_body_ = _data_body[0]) === null || _data_body_ === void 0 ? void 0 : _data_body_.text) && /* @__PURE__ */ React11.createElement(UitkSpacing5, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(EGDSStylizedText, {
        data: (_data_body1 = data.body) === null || _data_body1 === void 0 ? void 0 : _data_body1[0],
        overflow: "truncate-3-lines",
        weightOverride: data.state === "READ" /* READ */  ? "regular" : "bold"
    }))), ((_data_timeStamp = data.timeStamp) === null || _data_timeStamp === void 0 ? void 0 : _data_timeStamp.text) && /* @__PURE__ */ React11.createElement(UitkSpacing5, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(EGDSStylizedText, {
        data: data.timeStamp
    }))))), /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React11.createElement(UitkCardContentSection2, {
        padded: [
            "blockstart",
            "blockend",
            "inlineend"
        ]
    }, children)))));
};
NotificationsItem.fragment = fragment7;
NotificationsItem.displayName = "NotificationsItem";
// src/components/preview-menu/preview-menu-content-wrapper.tsx
import { UitkFloatingDotNotificationBadge as UitkFloatingDotNotificationBadge2 } from "uitk-react-badge";
import { UitkButtonSize as UitkButtonSize4, UitkTertiaryButton as UitkTertiaryButton3 } from "uitk-react-button";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkLoader } from "uitk-react-loader";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "uitk-react-menu";
// src/components/preview-menu/preview-menu-content.tsx
import React12 from "react";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker4, useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkPrimaryButton } from "uitk-react-button";
import { UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3 } from "uitk-react-text";
// src/mutation/update-notification-in-menu-mutation.ts
import { gql as gql9 } from "@apollo/client";
var __UpdateNotificationsInMenuMutation = gql9(_templateObject8());
// src/components/preview-menu/preview-menu-content.tsx
var CommunicationCenterPreviewMenuContent = function(props) {
    var _impressionAnalytics_, _impressionAnalytics, _impressionAnalytics_1, _impressionAnalytics1, _impressionAnalytics_2, _impressionAnalytics2, _impressionAnalytics_3, _impressionAnalytics3, _clickToActionButton, _actionButton, _clickAnalytics, _clickAnalytics1, _heading, _state_notificationsList;
    var heading = props.heading, emptyState = props.emptyState, clickToActionButton = props.clickToActionButton, impressionAnalytics = props.impressionAnalytics;
    var context = useBexApi3().context;
    var analyticsTracker = useClickTracker6();
    var impressionReferrerId = (_impressionAnalytics = impressionAnalytics) === null || _impressionAnalytics === void 0 ? void 0 : (_impressionAnalytics_ = _impressionAnalytics[0]) === null || _impressionAnalytics_ === void 0 ? void 0 : _impressionAnalytics_.referrerId;
    var impressionLinkName = ((_impressionAnalytics1 = impressionAnalytics) === null || _impressionAnalytics1 === void 0 ? void 0 : (_impressionAnalytics_1 = _impressionAnalytics1[0]) === null || _impressionAnalytics_1 === void 0 ? void 0 : _impressionAnalytics_1.linkName) || "";
    var buttonImpressionReferrerId = (_impressionAnalytics2 = impressionAnalytics) === null || _impressionAnalytics2 === void 0 ? void 0 : (_impressionAnalytics_2 = _impressionAnalytics2[1]) === null || _impressionAnalytics_2 === void 0 ? void 0 : _impressionAnalytics_2.referrerId;
    var buttonImpressionLinkName = ((_impressionAnalytics3 = impressionAnalytics) === null || _impressionAnalytics3 === void 0 ? void 0 : (_impressionAnalytics_3 = _impressionAnalytics3[1]) === null || _impressionAnalytics_3 === void 0 ? void 0 : _impressionAnalytics_3.linkName) || "";
    var actionButton = (_clickToActionButton = clickToActionButton) === null || _clickToActionButton === void 0 ? void 0 : _clickToActionButton.button;
    var clickAnalytics = (_actionButton = actionButton) === null || _actionButton === void 0 ? void 0 : _actionButton.analytics;
    var referrerId = (_clickAnalytics = clickAnalytics) === null || _clickAnalytics === void 0 ? void 0 : _clickAnalytics.referrerId;
    var linkName = (_clickAnalytics1 = clickAnalytics) === null || _clickAnalytics1 === void 0 ? void 0 : _clickAnalytics1.linkName;
    var state = useNotificationsList().state;
    var mutation = useUpdateNotificationsMutationState().mutation;
    var getNotificationIds = function(listOfNotifications) {
        var _listOfNotifications;
        return ((_listOfNotifications = listOfNotifications) === null || _listOfNotifications === void 0 ? void 0 : _listOfNotifications.map(function(notification) {
            return notification.cardId || "";
        }).filter(function(notificationId) {
            return notificationId !== "";
        })) || [];
    };
    var onClickToActionButtonClick = function() {
        if (referrerId && linkName) {
            analyticsTracker(referrerId, linkName);
        }
    };
    React12.useEffect(function() {
        var _state_notificationsList;
        var unseenNotifications = ((_state_notificationsList = state.notificationsList) === null || _state_notificationsList === void 0 ? void 0 : _state_notificationsList.filter(function(notification) {
            return notification.state === "UNSEEN" /* UNSEEN */ ;
        })) || [];
        var notificationIds = getNotificationIds(unseenNotifications);
        if (unseenNotifications && unseenNotifications.length > 0) {
            mutation({
                variables: {
                    contextInput: context,
                    notificationIds: notificationIds,
                    state: "SEEN" /* SEEN */ 
                }
            });
        }
    }, [
        state.notificationsList,
        context,
        mutation
    ]);
    if (state.notificationsList.length === 0) {
        var _heading1;
        return /* @__PURE__ */ React12.createElement(React12.Fragment, null, /* @__PURE__ */ React12.createElement(UitkCardContentSection3, {
            padded: true,
            border: "bottom"
        }, heading && /* @__PURE__ */ React12.createElement(UitkHeading3, {
            size: 5,
            tag: "h1"
        }, (_heading1 = heading) === null || _heading1 === void 0 ? void 0 : _heading1.text)), /* @__PURE__ */ React12.createElement(UitkSpacing6, {
            padding: {
                blockstart: "twelve"
            }
        }, /* @__PURE__ */ React12.createElement("section", null, emptyState && /* @__PURE__ */ React12.createElement(CommunicationCenterEmptyState, {
            data: emptyState
        }))));
    }
    return /* @__PURE__ */ React12.createElement(React12.Fragment, null, impressionReferrerId && /* @__PURE__ */ React12.createElement(IntersectionTracker4, {
        referrerId: impressionReferrerId,
        linkName: impressionLinkName
    }, /* @__PURE__ */ React12.createElement(UitkCardContentSection3, {
        padded: true,
        border: "bottom"
    }, heading && /* @__PURE__ */ React12.createElement(UitkHeading3, {
        size: 5,
        tag: "h1"
    }, (_heading = heading) === null || _heading === void 0 ? void 0 : _heading.text)), /* @__PURE__ */ React12.createElement("section", null, (_state_notificationsList = state.notificationsList) === null || _state_notificationsList === void 0 ? void 0 : _state_notificationsList.map(function(notification, index) {
        return /* @__PURE__ */ React12.createElement("div", {
            key: "notifications-cell-".concat(index),
            "data-stid": "notifications-cell"
        }, /* @__PURE__ */ React12.createElement(UitkSpacing6, {
            padding: {
                block: "half",
                inlinestart: "one",
                inlineend: "half"
            }
        }, /* @__PURE__ */ React12.createElement("div", null, /* @__PURE__ */ React12.createElement(NotificationsItem, {
            data: notification
        }))));
    })), clickToActionButton && actionButton && actionButton.primary && /* @__PURE__ */ React12.createElement(React12.Fragment, null, buttonImpressionReferrerId && /* @__PURE__ */ React12.createElement(IntersectionTracker4, {
        referrerId: buttonImpressionReferrerId,
        linkName: buttonImpressionLinkName
    }, /* @__PURE__ */ React12.createElement(UitkLayoutPosition, {
        display: "block",
        position: {
            bottom: "zero"
        },
        type: "absolute",
        style: {
            width: "100%"
        }
    }, /* @__PURE__ */ React12.createElement(UitkCardContentSection3, {
        padded: true,
        border: "top"
    }, /* @__PURE__ */ React12.createElement(UitkLayoutFlex5, {
        justifyContent: "center"
    }, /* @__PURE__ */ React12.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React12.createElement(UitkPrimaryButton, {
        tag: "a",
        href: "/inbox/notifications",
        onClick: onClickToActionButtonClick
    }, actionButton.primary)))))))));
};
CommunicationCenterPreviewMenuContent.displayName = "CommunicationCenterPreviewMenuContent";
var CommunicationCenterPreviewMenuContentWithContext = function(props) {
    var _notificationsObject, _notificationsObject1, _notificationsObject2, _notificationsObject3, _notificationsObject4, _notificationsObject5;
    var data = props.data, errorBannerAction = props.errorBannerAction;
    var notificationsObject = data.notifications;
    var heading = (_notificationsObject = notificationsObject) === null || _notificationsObject === void 0 ? void 0 : _notificationsObject.heading;
    var emptyState = (_notificationsObject1 = notificationsObject) === null || _notificationsObject1 === void 0 ? void 0 : _notificationsObject1.emptyState;
    var clickToActionButton = (_notificationsObject2 = notificationsObject) === null || _notificationsObject2 === void 0 ? void 0 : _notificationsObject2.clickToActionButton;
    var notificationsList = (_notificationsObject3 = notificationsObject) === null || _notificationsObject3 === void 0 ? void 0 : _notificationsObject3.notifications;
    var impressionAnalytics = (_notificationsObject4 = notificationsObject) === null || _notificationsObject4 === void 0 ? void 0 : _notificationsObject4.impressionAnalytics;
    var banner = (_notificationsObject5 = notificationsObject) === null || _notificationsObject5 === void 0 ? void 0 : _notificationsObject5.banner;
    var bannerActionHandler = function() {
        if (errorBannerAction) {
            errorBannerAction();
        }
    };
    if (banner) {
        return /* @__PURE__ */ React12.createElement(CommunicationCenterBanner, {
            data: banner,
            onBannerClick: bannerActionHandler,
            isFlexLayout: true
        });
    }
    return /* @__PURE__ */ React12.createElement(NotificationsListProvider, {
        notificationsList: notificationsList || [],
        unseenCount: 0
    }, /* @__PURE__ */ React12.createElement(NotificationsUpdateProvider, {
        mutationFunction: __UpdateNotificationsInMenuMutation
    }, /* @__PURE__ */ React12.createElement(CommunicationCenterPreviewMenuContent, {
        heading: heading,
        emptyState: emptyState,
        clickToActionButton: clickToActionButton,
        impressionAnalytics: impressionAnalytics
    })));
};
CommunicationCenterPreviewMenuContentWithContext.displayName = "sharedui-CommunicationCenterPreviewMenuContentWithContext";
// src/components/preview-menu/preview-menu-content-wrapper.tsx
var __CommunicationCenterPreviewQuery = gql10(_templateObject9(), EGDSStylizedText.fragment, CommunicationCenterEmptyState.fragment, NotificationsItem.fragment, CommunicationCenterBanner.fragment);
var CommunicationCenterPreviewMenuContentWrapper = function(props) {
    var _clickAnalytics, _clickAnalytics1, _impressionAnalytics, _impressionAnalytics1;
    var context = useBexApi4().context;
    var analyticsTracker = useClickTracker7();
    var unseen = props.unseen, unread = props.unread, icon = props.icon, impressionAnalytics = props.impressionAnalytics, clickAnalytics = props.clickAnalytics;
    var referrerId = (_clickAnalytics = clickAnalytics) === null || _clickAnalytics === void 0 ? void 0 : _clickAnalytics.referrerId;
    var linkName = (_clickAnalytics1 = clickAnalytics) === null || _clickAnalytics1 === void 0 ? void 0 : _clickAnalytics1.linkName;
    var _React13_useState = _sliced_to_array(React13.useState(false), 2), isOpen = _React13_useState[0], setOpen = _React13_useState[1];
    var totalUnseenCount = unseen + unread;
    var unseenState = totalUnseenCount > 0;
    var _React13_useState1 = _sliced_to_array(React13.useState(unseenState), 2), isUnSeen = _React13_useState1[0], setUnSeen = _React13_useState1[1];
    var _React13_useState2 = _sliced_to_array(React13.useState(false), 1), menuClickHandlerState = _React13_useState2[0];
    var impressionReferrerId = (_impressionAnalytics = impressionAnalytics) === null || _impressionAnalytics === void 0 ? void 0 : _impressionAnalytics.referrerId;
    var impressionLinkName = ((_impressionAnalytics1 = impressionAnalytics) === null || _impressionAnalytics1 === void 0 ? void 0 : _impressionAnalytics1.linkName) || "";
    var _useLazyQuery = _sliced_to_array(useLazyQuery(__CommunicationCenterPreviewQuery, {
        variables: {
            context: context,
            optionalContext: {
                dropdownView: true
            }
        },
        ssr: false
    }), 2), loadNotifications = _useLazyQuery[0], _useLazyQuery_ = _useLazyQuery[1], called = _useLazyQuery_.called, loading = _useLazyQuery_.loading, data = _useLazyQuery_.data, error = _useLazyQuery_.error, refetch = _useLazyQuery_.refetch;
    var onMenuTriggerClick = function() {
        setOpen(!isOpen);
        if (unseen < 4) {
            setUnSeen(false);
        }
        if (!called) {
            loadNotifications({
                context: context
            });
        }
        if (!isOpen && referrerId && linkName) {
            analyticsTracker(referrerId, linkName, void 0, []);
        }
    };
    var _icon_description;
    return /* @__PURE__ */ React13.createElement(UitkLayoutFlexItem6, {
        minWidth: "zero",
        grow: 0
    }, /* @__PURE__ */ React13.createElement(UitkMenu, {
        isOpen: isOpen,
        onTriggerClick: onMenuTriggerClick,
        disableBodyClickHandler: menuClickHandlerState
    }, /* @__PURE__ */ React13.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React13.createElement(UitkTertiaryButton3, {
        className: "uitk-button-only-icon global-navigation-nav-button",
        size: UitkButtonSize4.LARGE
    }, /* @__PURE__ */ React13.createElement(UitkLayoutPosition2, {
        display: "inline-block",
        type: "relative"
    }, /* @__PURE__ */ React13.createElement(UitkIcon5, {
        name: icon.id,
        size: UitkIconSize2.LARGE,
        id: "".concat(icon.id, "-icon"),
        title: (_icon_description = icon.description) !== null && _icon_description !== void 0 ? _icon_description : ""
    }), /* @__PURE__ */ React13.createElement(UitkLayoutPosition2, {
        cloneElement: true,
        position: {
            right: "zero",
            top: "zero"
        },
        type: "absolute"
    }, /* @__PURE__ */ React13.createElement(UitkLayoutPosition2, {
        cloneElement: true,
        position: {
            right: "zero",
            top: "zero"
        },
        type: "absolute"
    }, impressionReferrerId && /* @__PURE__ */ React13.createElement(IntersectionTracker5, {
        referrerId: impressionReferrerId,
        linkName: impressionLinkName
    }, isUnSeen && /* @__PURE__ */ React13.createElement(UitkFloatingDotNotificationBadge2, {
        visible: true
    }))))))), /* @__PURE__ */ React13.createElement(UitkMenuContainer, {
        position: PositionType.RIGHT,
        width: 375,
        maxHeight: 576
    }, /* @__PURE__ */ React13.createElement("div", {
        style: {
            height: 576
        },
        role: "menu"
    }, (loading || error) && /* @__PURE__ */ React13.createElement(UitkLayoutFlex6, {
        justifyContent: "center",
        alignItems: "center",
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React13.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React13.createElement(UitkLoader, null))), !loading && !error && data && data.communicationCenterPreview && /* @__PURE__ */ React13.createElement(CommunicationCenterPreviewMenuContentWithContext, {
        data: data.communicationCenterPreview,
        errorBannerAction: refetch
    })))));
};
CommunicationCenterPreviewMenuContentWrapper.displayName = "sharedui-CommunicationCenterPreviewMenuContentWrapper";
// src/components/preview-menu/preview-menu-icon-content.tsx
import React14 from "react";
import { IntersectionTracker as IntersectionTracker6, useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { UitkFloatingDotNotificationBadge as UitkFloatingDotNotificationBadge3 } from "uitk-react-badge";
import { UitkButtonSize as UitkButtonSize5, UitkTertiaryButton as UitkTertiaryButton4 } from "uitk-react-button";
import { UitkIcon as UitkIcon6, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkLayoutPosition as UitkLayoutPosition3 } from "uitk-react-layout-position";
var CommunicationCenterPreviewMenuIconContent = function(props) {
    var _clickAnalytics, _clickAnalytics1, _clickAnalyticsForMessage, _clickAnalyticsForMessage1, _impressionAnalytics, _impressionAnalytics1;
    var analyticsTracker = useClickTracker8();
    var unseen = props.unseen, unread = props.unread, icon = props.icon, impressionAnalytics = props.impressionAnalytics, clickAnalytics = props.clickAnalytics, clickAnalyticsForMessage = props.clickAnalyticsForMessage;
    var referrerId = (_clickAnalytics = clickAnalytics) === null || _clickAnalytics === void 0 ? void 0 : _clickAnalytics.referrerId;
    var linkName = (_clickAnalytics1 = clickAnalytics) === null || _clickAnalytics1 === void 0 ? void 0 : _clickAnalytics1.linkName;
    var messageReferrerId = (_clickAnalyticsForMessage = clickAnalyticsForMessage) === null || _clickAnalyticsForMessage === void 0 ? void 0 : _clickAnalyticsForMessage.referrerId;
    var messageLinkName = (_clickAnalyticsForMessage1 = clickAnalyticsForMessage) === null || _clickAnalyticsForMessage1 === void 0 ? void 0 : _clickAnalyticsForMessage1.linkName;
    var totalUnseenCount = unseen + unread;
    var unseenState = totalUnseenCount > 0;
    var _React14_useState = _sliced_to_array(React14.useState(unseenState), 2), isUnSeen = _React14_useState[0], setUnSeen = _React14_useState[1];
    var impressionReferrerId = (_impressionAnalytics = impressionAnalytics) === null || _impressionAnalytics === void 0 ? void 0 : _impressionAnalytics.referrerId;
    var impressionLinkName = ((_impressionAnalytics1 = impressionAnalytics) === null || _impressionAnalytics1 === void 0 ? void 0 : _impressionAnalytics1.linkName) || "";
    var onMenuIconClick = function() {
        setUnSeen(false);
        if (referrerId && linkName) {
            analyticsTracker(referrerId, linkName, void 0, []);
        }
        if (messageReferrerId && messageLinkName) {
            analyticsTracker(messageReferrerId, messageLinkName, void 0, []);
        }
    };
    var _icon_description;
    return /* @__PURE__ */ React14.createElement("a", {
        href: "/inbox/notifications"
    }, /* @__PURE__ */ React14.createElement(UitkTertiaryButton4, {
        className: "uitk-button-only-icon global-navigation-nav-button",
        size: UitkButtonSize5.LARGE,
        onClick: onMenuIconClick
    }, /* @__PURE__ */ React14.createElement(UitkLayoutPosition3, {
        display: "inline-block",
        type: "relative"
    }, /* @__PURE__ */ React14.createElement(UitkIcon6, {
        name: icon.id,
        size: UitkIconSize3.LARGE,
        id: "".concat(icon.id, "-icon"),
        title: (_icon_description = icon.description) !== null && _icon_description !== void 0 ? _icon_description : ""
    }), /* @__PURE__ */ React14.createElement(UitkLayoutPosition3, {
        cloneElement: true,
        position: {
            right: "zero",
            top: "zero"
        },
        type: "absolute"
    }, /* @__PURE__ */ React14.createElement(UitkLayoutPosition3, {
        cloneElement: true,
        position: {
            right: "zero",
            top: "zero"
        },
        type: "absolute"
    }, impressionReferrerId && /* @__PURE__ */ React14.createElement(IntersectionTracker6, {
        referrerId: impressionReferrerId,
        linkName: impressionLinkName
    }, isUnSeen && /* @__PURE__ */ React14.createElement(UitkFloatingDotNotificationBadge3, {
        visible: true
    })))))));
};
CommunicationCenterPreviewMenuIconContent.displayName = "CommunicationCenterPreviewMenuIconContent";
// src/components/preview-menu/preview-menu-wrapper.tsx
var CommunicationCenterPreviewMenuWrapper = function(props) {
    var unseen = props.unseen, unread = props.unread, icon = props.icon, impressionAnalytics = props.impressionAnalytics, clickAnalytics = props.clickAnalytics, clickAnalyticsForMessage = props.clickAnalyticsForMessage, isPreviewMenuView = props.isPreviewMenuView;
    if (isPreviewMenuView) {
        return /* @__PURE__ */ React15.createElement(CommunicationCenterPreviewMenuContentWrapper, {
            unseen: unseen || 0,
            unread: unread || 0,
            icon: icon,
            impressionAnalytics: impressionAnalytics,
            clickAnalytics: clickAnalytics
        });
    }
    return /* @__PURE__ */ React15.createElement(CommunicationCenterPreviewMenuIconContent, {
        unseen: unseen || 0,
        unread: unread || 0,
        icon: icon,
        impressionAnalytics: impressionAnalytics,
        clickAnalytics: clickAnalytics,
        clickAnalyticsForMessage: clickAnalyticsForMessage
    });
};
CommunicationCenterPreviewMenuWrapper.displayName = "CommunicationCenterPreviewMenuWrapper";
// src/components/preview-menu/preview-menu.tsx
var __Query = gql11(_templateObject10());
var __HeaderQuery = gql11(_templateObject11());
var CommunicationCenterPreviewMenu = function(props) {
    var _data, _previewMenu, _previewMenu1, _previewMenu2, _previewMenu3, _previewMenu_impressionAnalytics, _previewMenu4, _previewMenu_clickAnalytics, _previewMenu5, _previewMenu_clickAnalytics1, _previewMenu6;
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_isPreviewMenuView = props.isPreviewMenuView, isPreviewMenuView = _props_isPreviewMenuView === void 0 ? false : _props_isPreviewMenuView, _props_messageCountEnabled = props.messageCountEnabled, messageCountEnabled = _props_messageCountEnabled === void 0 ? false : _props_messageCountEnabled;
    var lineOfBusiness = inputs.lineOfBusiness, viewSize = inputs.viewSize;
    var context = useBexApi5().context;
    var client = useApolloClient();
    var onCompleted = function(data2) {
        var _data2_communicationCenterEntryPoint, _data2, _data2_communicationCenterEntryPoint1, _data21, _context_identity, _context;
        var _data2_communicationCenterEntryPoint_notificationUnseenCount;
        var unseen = (_data2_communicationCenterEntryPoint_notificationUnseenCount = (_data2 = data2) === null || _data2 === void 0 ? void 0 : (_data2_communicationCenterEntryPoint = _data2.communicationCenterEntryPoint) === null || _data2_communicationCenterEntryPoint === void 0 ? void 0 : _data2_communicationCenterEntryPoint.notificationUnseenCount) !== null && _data2_communicationCenterEntryPoint_notificationUnseenCount !== void 0 ? _data2_communicationCenterEntryPoint_notificationUnseenCount : 0;
        var _data2_communicationCenterEntryPoint_messageUnseenCount;
        var unread = (_data2_communicationCenterEntryPoint_messageUnseenCount = (_data21 = data2) === null || _data21 === void 0 ? void 0 : (_data2_communicationCenterEntryPoint1 = _data21.communicationCenterEntryPoint) === null || _data2_communicationCenterEntryPoint1 === void 0 ? void 0 : _data2_communicationCenterEntryPoint1.messageUnseenCount) !== null && _data2_communicationCenterEntryPoint_messageUnseenCount !== void 0 ? _data2_communicationCenterEntryPoint_messageUnseenCount : 0;
        var totalUnseenCount = unseen + unread;
        if (totalUnseenCount > 0 && ((_context = context) === null || _context === void 0 ? void 0 : (_context_identity = _context.identity) === null || _context_identity === void 0 ? void 0 : _context_identity.authState) === "AUTHENTICATED") {
            client.writeQuery({
                query: __HeaderQuery,
                data: {
                    globalHeader: {
                        redDotState: "VISIBLE" /* VISIBLE */ 
                    }
                },
                variables: {
                    context: context,
                    viewSize: viewSize,
                    lineOfBusiness: lineOfBusiness
                }
            });
        }
    };
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context,
        optionalContext: {
            messageCountEnabled: messageCountEnabled
        }
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: skipSsr,
        onCompleted: onCompleted
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data) {
        return null;
    }
    var previewMenu = (_data = data) === null || _data === void 0 ? void 0 : _data.communicationCenterEntryPoint;
    var label = (_previewMenu = previewMenu) === null || _previewMenu === void 0 ? void 0 : _previewMenu.label;
    var icon = (_previewMenu1 = previewMenu) === null || _previewMenu1 === void 0 ? void 0 : _previewMenu1.icon;
    var notificationUnseenCount = (_previewMenu2 = previewMenu) === null || _previewMenu2 === void 0 ? void 0 : _previewMenu2.notificationUnseenCount;
    var messageUnreadCount = (_previewMenu3 = previewMenu) === null || _previewMenu3 === void 0 ? void 0 : _previewMenu3.messageUnseenCount;
    var impressionAnalytics = (_previewMenu4 = previewMenu) === null || _previewMenu4 === void 0 ? void 0 : (_previewMenu_impressionAnalytics = _previewMenu4.impressionAnalytics) === null || _previewMenu_impressionAnalytics === void 0 ? void 0 : _previewMenu_impressionAnalytics[0];
    var clickAnalytics = (_previewMenu5 = previewMenu) === null || _previewMenu5 === void 0 ? void 0 : (_previewMenu_clickAnalytics = _previewMenu5.clickAnalytics) === null || _previewMenu_clickAnalytics === void 0 ? void 0 : _previewMenu_clickAnalytics[0];
    var clickAnalyticsForMessage = (_previewMenu6 = previewMenu) === null || _previewMenu6 === void 0 ? void 0 : (_previewMenu_clickAnalytics1 = _previewMenu6.clickAnalytics) === null || _previewMenu_clickAnalytics1 === void 0 ? void 0 : _previewMenu_clickAnalytics1[1];
    return /* @__PURE__ */ React16.createElement(Viewport2, null, /* @__PURE__ */ React16.createElement(ViewMedium2, null, /* @__PURE__ */ React16.createElement(CommunicationCenterPreviewMenuWrapper, {
        isPreviewMenuView: isPreviewMenuView,
        unseen: notificationUnseenCount || 0,
        unread: messageUnreadCount || 0,
        icon: icon,
        impressionAnalytics: impressionAnalytics,
        clickAnalytics: clickAnalytics,
        clickAnalyticsForMessage: clickAnalyticsForMessage
    })), /* @__PURE__ */ React16.createElement(ViewSmall2, null, /* @__PURE__ */ React16.createElement(CommunicationCenterPreviewMenuLinkContent, {
        unseen: notificationUnseenCount || 0,
        unread: messageUnreadCount || 0,
        label: label || "",
        impressionAnalytics: impressionAnalytics,
        clickAnalytics: clickAnalytics,
        clickAnalyticsForMessage: clickAnalyticsForMessage
    })));
};
CommunicationCenterPreviewMenu.displayName = "sharedui-CommunicationCenterPreviewMenu";
export { CommunicationCenterPreviewMenu };
//# sourceMappingURL=index.js.map